import type { AuthError } from '@/root/shared-types/api/auth'
import { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'
import { AUTH_ERROR_CODES } from '@/root/modules/tuuleliinid/LoginPage/constants'

type TranslationFn = (key: Key) => string

const errorCodeToTranslationKey: Record<string, Key> = {
  [AUTH_ERROR_CODES.USER_NOT_FOUND]: 'userNotExist',
  [AUTH_ERROR_CODES.USER_NOT_EXIST]: 'userNotExist',
  [AUTH_ERROR_CODES.INVALID_CREDENTIALS]: 'userNotValid',
  [AUTH_ERROR_CODES.AUTH_FAILED]: 'userNotValid',
  [AUTH_ERROR_CODES.USER_ALREADY_EXISTS]: 'authSignupUserExists',
  [AUTH_ERROR_CODES.USER_ALREADY_ACTIVATED]: 'authActivationAlreadyActivated',
  [AUTH_ERROR_CODES.INVALID_EMAIL]: 'authSignupInvalidEmail',
  [AUTH_ERROR_CODES.WEAK_PASSWORD]: 'authSignupWeakPassword',
  [AUTH_ERROR_CODES.WEBEID_EXTENSION_UNAVAILABLE]: 'authErrorWebeidNotAvailable',
  [AUTH_ERROR_CODES.WEBEID_NATIVE_UNAVAILABLE]: 'authErrorWebeidNativeNotAvailable',
  [AUTH_ERROR_CODES.WEBEID_USER_TIMEOUT]: 'authErrorWebeidTimeout',
  [AUTH_ERROR_CODES.WEBEID_CERT_EXPIRED]: 'authErrorCertificateExpired',
  [AUTH_ERROR_CODES.WEBEID_CONTEXT_INSECURE]: 'authErrorHttpsRequired',
  [AUTH_ERROR_CODES.WEBEID_NATIVE_FATAL]: 'authErrorCardReaderNotFound',
  [AUTH_ERROR_CODES.WEBEID_VERSION_MISMATCH]: 'authErrorWebeidVersionMismatch',
  [AUTH_ERROR_CODES.WEBEID_VERIFY_FAILED]: 'authErrorVerifyFailed',
  [AUTH_ERROR_CODES.WEBEID_ACTION_PENDING]: 'authErrorWebeidTimeout',
  [AUTH_ERROR_CODES.CHALLENGE_EXPIRED]: 'authErrorChallengeExpired',
}

export const getAuthErrorMessage = (error: AuthError | null, getTranslation: TranslationFn): string => {
  if (!error) return getTranslation('loginAuthGeneralError')

  const translationKey = error.code ? errorCodeToTranslationKey[error.code] : undefined
  if (translationKey) return getTranslation(translationKey)

  return getTranslation('loginAuthGeneralError')
}
